import React from 'react';
import { Box, Button } from '@mui/material';

interface DashboardButtonProps {
  label: string;
  width: number;
  height: number;
  backgroundColor: string;
  textColor: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  borderRadius?: string | number;
  border?: string;
  /**
   * Render as a static badge instead of a button: no ripple, no hover, not
   * focusable. Use for labels that only report state (فعال / غیرفعال / ...)
   * and do nothing when clicked.
   */
  badge?: boolean;
}

const DashboardButton: React.FC<DashboardButtonProps> = ({
  label,
  width,
  height,
  backgroundColor,
  textColor,
  startIcon,
  borderRadius = '0px',
  border = 'none',
  endIcon,
  badge = false,
}) => {
  const sharedStyle: React.CSSProperties = {
    width: `${width}px`,
    height: `${height}px`,
    backgroundColor,
    color: textColor,
    direction: 'rtl',
    padding: '2px 4px',
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '6px',
    fontFamily: 'IRANYekanXFaNum',
    fontWeight: 600,
    fontSize: '10px',
    lineHeight: '15.6px',
    border,
    outline: 'none',
    borderRadius,
  };

  if (badge) {
    return (
      <Box
        component="span"
        // A status label, not a control: announce it as such and keep the
        // pointer arrow so it does not invite a click.
        role="status"
        sx={{
          ...sharedStyle,
          display: 'inline-flex',
          flexShrink: 0,
          cursor: 'default',
          userSelect: 'none',
          whiteSpace: 'nowrap',
        }}
      >
        {startIcon}
        {label}
        {endIcon}
      </Box>
    );
  }

  return (
    <Button
      variant="contained"
      startIcon={startIcon}
      endIcon={endIcon}
      style={{
        ...sharedStyle,
        boxShadow: '0.7px 0.7px 0.7px 0.7px rgba(0, 0, 0, 0)',
      }}
    >
      {label}
      {endIcon && (
        <span style={{ marginLeft: '0px', marginRight: '0px' }}></span>
      )}
    </Button>
  );
};

export default DashboardButton;
